export enum TreeSortMode {
  alphabetical = 'alphabetical',
  lastUpdated = 'lastUpdated',
  firstUpload = 'firstUpload',
  lastUpload = 'lastUpload',
}
